import React from 'react';
import { useParams } from 'react-router-dom';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import Form, { Actions, RequiredValidator, Wysiwyg } from '../../../Components/Form';
import { useTemplate } from '../../../Data/Templates';
import Tabs, { Tab } from '../../../Components/Containers/Tabs/Tabs';
import CopyableValue from '../../../Components/Formatting/CopyableValue';

const MessageTemplate = () => {
    const {templateId} = useParams();
    const {template, update} = useTemplate(templateId);

    return <>
        <TopBar left="BackBtn" title={template?.title ?? 'Message Template'} />

        <Page zeroPad className="page-padding">
            <Form data={template} waitForData goBackOnSubmit onSubmit={(data) => update({...data, rich: null})}>
                <Tabs className="mt-0">
                    <Tab title="Email">
                        <Wysiwyg name="subjectUpgraded"
                            label="Subject line"
                            validators={[RequiredValidator]}
                            features={['mergetags']}
                            mode="singleLine"
                            bottomMargin="0"
                        />
                        <Wysiwyg name="html"
                            label="Body"
                            validators={[RequiredValidator]}
                            features={['mergetags', 'basicFormatting']}
                            mode="html"
                            bottomMargin="50"
                        />
                        <div className="prose prose-sm my-4 text-muted">
                            <p>All emails include a link to the Customer Portal, you don't need to provide one in the message template.</p>
                        </div>
                    </Tab>
                    <Tab title="SMS">
                        <Wysiwyg name="shortUpgraded"
                            label="SMS Message"
                            validators={[RequiredValidator]}
                            features={['mergetags']}
                            mode="multiLine"
                            bottomMargin="10"
                        />

                        <div className="prose prose-sm my-4 text-muted">
                            <p>
                                To provide customers a way to log in to the Customer Portal, you can use secure links or a PIN. For example:
                            </p>

                            <p>This will provide a link to your website and PIN number which they need to log in:</p>

                            <CopyableValue value={`Visit {{business.website}} and log in using {{customer.pin}}`} />

                            <p>
                                This will provide a secure link directly into the Customer Portal:
                            </p>

                            <CopyableValue value={`Log in at {{link.short}}`} />

                            <p>
                                <strong>Caution:</strong> Some phone networks may not deliver secure links reliably as they can be mistaken for phishing attacks.
                            </p>
                        </div>
                    </Tab>
                </Tabs>
                <Actions submit={{label: 'Save'}} />
            </Form>
        </Page>
    </>
}

export default MessageTemplate;
